import type { UserListUserActivitiesParams } from '../api'
import { api } from '../api'

const getList = async (data: UserListUserActivitiesParams) => {
  const { skip = 0, limit = 10, fromTimeUnix = 0, toTimeUnix = 0 } = data
  return await api.v1.userListUserActivities({
    skip,
    limit,
    fromTimeUnix,
    toTimeUnix,
  })
}

export default {
  getList,
}
